import { Calendar, Download } from 'lucide-react'
import { PeriodSelector } from '@/components/ui/FormComponents'
import type { MetricPeriod } from '@/lib/utils'

interface HistoryToolbarProps {
  period: MetricPeriod
  canGoNext: boolean
  onPrevious: () => void
  onNext: () => void
  onOpenPeriodPlan: () => void
  showExcelExport?: boolean
  showNextMonthPlan?: boolean
  isCurrentPeriod?: boolean
  onExcelExport?: () => Promise<void>
  onNextMonthPlan?: () => void
}

export function HistoryToolbar({
  period,
  canGoNext,
  onPrevious,
  onNext,
  onOpenPeriodPlan,
  showExcelExport = false,
  showNextMonthPlan = false,
  isCurrentPeriod = false,
  onExcelExport,
  onNextMonthPlan,
}: HistoryToolbarProps) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
      <div className="flex-1 w-full sm:w-auto">
        <PeriodSelector
          period={period}
          onPrevious={onPrevious}
          onNext={onNext}
          canGoNext={canGoNext}
        />
      </div>
      <div className="flex w-full sm:w-auto">
        <div className="flex w-full sm:w-auto flex-col sm:flex-row gap-2">
          {showExcelExport && onExcelExport && (
            <button
              onClick={onExcelExport}
              className="flex items-center justify-center gap-2 py-2 px-4 bg-fixed-green-600 text-white rounded-lg hover:bg-fixed-green-700 transition-colors font-medium text-sm whitespace-nowrap"
              title="Экспортировать данные в Excel"
            >
              <Download className="w-4 h-4" />
              Управляйка в Excel
            </button>
          )}
          {showNextMonthPlan && isCurrentPeriod && onNextMonthPlan && (
            <button
              onClick={onNextMonthPlan}
              className="flex items-center justify-center gap-2 py-2 px-4 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium text-sm whitespace-nowrap"
              title="Установить план на следующий месяц"
            >
              <Calendar className="w-4 h-4" />
              План на месяц
            </button>
          )}
          <button
            onClick={onOpenPeriodPlan}
            className="flex w-full sm:w-auto items-center justify-center gap-2 rounded-lg bg-primary px-5 py-3 text-sm font-semibold whitespace-nowrap text-primary-foreground transition-colors hover:bg-primary/90"
            title="Открыть декомпозицию выбранного периода"
          >
            <Calendar className="w-4 h-4" />
            Заполнить план
          </button>
        </div>
      </div>
    </div>
  )
}
